import { FilterField } from '../../../types'

const fields: FilterField[] = [
  {
    id: 'name',
    display: 'Name',
    filterTypeIds: ['contains', 'blank', 'not_blank', 'equals', 'not_equals'],
  },
  {
    id: 'account',
    display: 'Account',
    filterTypeIds: ['contains', 'blank', 'not_blank', 'equals', 'not_equals'],
  },
  {
    id: 'city',
    display: 'City',
    filterTypeIds: ['contains', 'blank', 'not_blank', 'equals', 'not_equals'],
  },
  {
    id: 'state',
    display: 'State',
    filterTypeIds: ['contains', 'blank', 'not_blank', 'equals', 'not_equals'],
  },
]

export default fields
